import React, { useRef } from 'react';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import { useHistory } from 'react-router-dom';
import style from './style.scss';


// import { GENDER, PLACE_PAGE } from '../../config/constants';
// import { useQueryClient } from 'react-query';
// import checkAppDestination from '../../components/checkAppDestination';
// import checkInfoDestination from '../../components/checkInfoDestination';


function Info() {
  const history = useHistory();
  // const queryClient = useQueryClient();
  const ref = useRef();
  // const campaigns = authContext.campaigns;
  // const userProfile = authContext.userProfile
  // const [campaignInfos, setCampaignInfos] = useState([]);

  const goInfoPage = (infoItem) => {
    let url = `${process.env.RAZZLE_PUBLIC_URL}/info/` + infoItem.path;
    history.push({ pathname: url });
  };

  // useEffect(() => {
  //   const results = [];
  //   for (let obj of campaigns) {
  //     // TODO check logic
  //     const key = checkAppDestination(obj?.app_destination);
  //     let checkInfoPath = checkInfoDestination(obj?.app_destination);
  //     if ((key === '/point' || key === '/platium') && userProfile?.gender === GENDER.FEMALE && userProfile.banWomenBuy) {
  //       continue;
  //     }
  //     if ((key === '/plan_user' || key === 'contactafterlogin' || key === 'contactageverification')) {
  //       continue;
  //     }
  //
  //     if (checkInfoPath !== '#') {
  //       results.push({
  //         ...obj,
  //         palacePoint: PLACE_PAGE.POINT,
  //         palacePlan: PLACE_PAGE.PLAN,
  //         keyPath: `/webview_web/Information/DetailInfo/${checkInfoPath}`,
  //         gender: userProfile?.gender,
  //         banWomenBuy: userProfile?.banWomenBuy,
  //       });
  //     }
  //   }
  //   setCampaignInfos(results);
  // }, [campaigns]);

  //
  // useEffect(() => {
  //   const iFrameElement = ref && ref.current;
  //
  //   if (iFrameElement && campaignInfos.length) {
  //     const iFrameWindow = iFrameElement.contentWindow;
  //
  //     setInterval(() => {
  //       const payload = {
  //         event: 'INFO_CAMPAIGNS',
  //         campaigns: campaignInfos,
  //       };
  //       iFrameWindow?.postMessage(JSON.stringify(payload), '*');
  //     }, 800);
  //   }
  // }, [ref, campaignInfos]);

  return (
    <div style={{ maxWidth: 560, margin: 'auto' }} className={style.list__item}>
      <TopNav name="お知らせ_GitWebInfoIndex" hasBackIcon={true} hasHamburger={true} />
      <div className={`${style.info__container}`} style={{ marginTop: 50 }}>
        <iframe allow="document-domain 'none'" ref={ref}
                src={`/webview_web/Information/infopage_menu_web.html?var=${Math.random()}`}
                title="Info" />
      </div>
      <BottomNav />
    </div>
  );
}

export default Info;
